import { EventStore, TrackingClient } from '@novacredit/frontend-common/tracking';

const CATEGORY = 'marketing';
const APP_NAME = 'client-analytics';

const tracker = new TrackingClient({
	destinations: [new EventStore({ appName: APP_NAME, category: CATEGORY })],
	appName: APP_NAME,
});

// Export an initialized tracking client to make test
// mocking easier.
export default tracker;
